import Input from 'Components/Input';
import SelectInput from 'Components/SelectInput';
import { FieldArray } from 'formik';
import { BusinessPartnerSetupFormType } from './index';
import { twMerge } from 'tailwind-merge';
import { weightOptions } from 'Constants';

type XAxisSetupProps = {
  values: BusinessPartnerSetupFormType;
  className?: string;
};

const XAxisSetup = (props: XAxisSetupProps) => {
  const { values, className } = props;
  return (
    <div className={twMerge('flex-col w-full', className)}>
      <div className="flex w-full">
        <Input
          label="X-axis name"
          name="xaxis_name"
          type="text"
          placeholder="Xaxis name Example"
        />
      </div>
      <hr />
      <div className="mt-3 flex flex-col w-full">
        <FieldArray name="xaxis_questions">
          {() => (
            <div className="w-full">
              {values.xaxis_questions.length > 0 &&
                values.xaxis_questions.map((question, index) => (
                  <div className="flex w-full" key={'xaxis_questions-' + index}>
                    <Input
                      label={'Question #' + (index + 1)}
                      name={`xaxis_questions.${index}.question`}
                      type="text"
                      placeholder="Business Partner Example"
                      className="min-w-[250px]"
                    />
                    <SelectInput
                      label={'Weight'}
                      name={`xaxis_questions.${index}.weight`}
                      options={weightOptions}
                      outerDivClassName="ml-2 w-[150px]"
                    />
                  </div>
                ))}
            </div>
          )}
        </FieldArray>
      </div>
    </div>
  );
};

export default XAxisSetup;
